import { getAuthenticatedRequestInit } from './utils';
import { getApiHost } from '../utils/hosts';

export default async function CallSipUser(
	token: string,
	sipUri: string,
	meetingId: string,
	connectionName?: string,
	safetyImageUri?: string,
) {
	try {
		const res = await fetch(`${getApiHost()}/v2/greenroom/call-sip-user/${meetingId}`, {
			method: 'POST',
			body: JSON.stringify({
				sipUri,
				connectionName,
				safetyImageUri,
			}),
			...getAuthenticatedRequestInit(token),
		});
		if (res.ok) return res.json();
		return { message: 'Response Error' };
	} catch (e) {
		console.error(e);
		return { message: 'Connection Error' };
	}
}
